module.exports = __webpack_public_path__ + "static/img/product_images_16_h5_zh.2a62639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_16_h5_zh.png
// module id = Xj3U
// module chunks = 34